// TapGo 어플리케이션의 메인 색상 정의
export const COLORS = {
  primary: '#FF6F0F',    // 주황색
  secondary: '#3A46B1',  // 남색
  white: '#FFFFFF',
  lightGray: '#F5F5F5',
  gray: '#CCCCCC',
  darkGray: '#666666',
  black: '#000000',
  appBar: '#FFFAF5',     // 앱바 배경색
  
  // 플랜 카드 관련 색상
  planCardBg: 'rgba(255, 111, 15, 0.05)',   // #FF6F0F 5% 투명도
  subscribeButtonBg: 'rgba(255, 94, 7, 0.15)',  // #FF5E07 15% 투명도
  
  // 테이블 행 색상 추가
  tableHeaderRow: 'rgba(255, 111, 15, 0.2)', // #FF6F0F33의 20%
  tableDateRow: 'rgba(58, 70, 177, 0.1)',    // #3A46B11A의 10%
  tableSummaryRow: 'rgba(0, 0, 0, 0.05)',    // #0000000D의 5%
};

export default COLORS;
